/** @format */

import { AnalyticsService } from '@shared/data-access/services';
import { Injectable } from '@angular/core';

/** @dynamic */
@Injectable({
  providedIn: 'root',
})
export class CategoryAnalyticsService extends AnalyticsService {
  /**
   * @ngdoc method
   * @name dcsg.app.services.service:AnalyticsService#setDYMTerm
   * @methodOf dcsg.app.services.service:AnalyticsService
   *
   * @param CategoryID - The Category ID
   *
   * @description
   * Pull the pages category id
   */
  setCategoryID(CategoryID: string): void {
    this.window.siteData.CategoryID = CategoryID;
  }

  /**
   * @ngdoc method
   * @name dcsg.app.services.service:AnalyticsService#setDYMTerm
   * @methodOf dcsg.app.services.service:AnalyticsService
   *
   * @param CategoryName - The Category Name
   *
   * @description
   * Pulls the pages category name
   */
  setCategoryName(CategoryName: string): void {
    this.window.siteData.CategoryName = CategoryName;
  }
}
